import { SubjectMessage } from '@surveycake/logic-engine';
import { Wording } from '@surveycake/wording/survey';
import { errorMap } from './errorMap';
import { infoMap } from './infoMap';
import { MessageResolver, MessageType } from './types';

const resolverMaps = { error: errorMap, info: infoMap };

export function createMessageResolver<T extends MessageType>(
  type: T
): MessageResolver<T> {
  const resolverMap = resolverMaps[type];
  return function messageResolver(
    wording: Wording,
    message: SubjectMessage[T]
  ) {
    const resolver: MessageResolver<T> = (resolverMap as any)[message.type];
    return resolver ? resolver(wording, message) : undefined;
  };
}
